module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['APIManager']
    script.onload = () => resolve({
      get: (request) => window['APIManager'].get(request),
      init: (arg) => {
        try {
          return window['APIManager'].init(arg)
        } catch(e) {
          console.log('remote container already initialized')
        }
      }
    })
    document.head.appendChild(script);
  });